var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"tags text-lowercase"},[_c('span',[_vm._v(" "+_vm._s(_vm._f("truncate")(_vm.tags,30, '...'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }